export default {
  data() {
    return {
      activePage: null,
      pages: [
        {
          id: "1",
          title: "Page 1",
          body: "<h1>Yeet</h1>",
        },
        {
          id: "2",
          title: "Page 2",
          body: "<h1>Yeet 2</h1>",
        },
        {
          id: "3",
          title: "Page 3",
          body: "<h1>Yeet 3</h1>",
        },
        {
          id: "4",
          title: "Page 4",
          body: "<h1>Yeet 4</h1>",
        },
      ],
      isLoading: false,
      isPagesLoading: false,
      dummy: {
        id: null,
        title: "",
        body: "",
      },
    };
  },

  created() {
    this.isLoading = true;
    this.getPages();
  },
  methods: {
    setActivePage(id) {
      if (id) {
        //is existing page
        this.activePage = this.pages.filter((page) => page.id === id)[0];
      } else {
        //is dummy
        this.activePage = this.dummy;
      }
    },
    getPages() {
      this.isPagesLoading = true;

      //TO DO fetch

      if (!this.activePage) {
        //is empty
        this.activePage = this.pages[0];
      }
      this.isLoading = false;
      this.isPagesLoading = false;
    },
    deletePage(id) {
      this.isPagesLoading = true;

      //clear active page
      this.activePage = null;

      //TO DO fetch to delete

      //then get new pages
      // this.getPages();
    },
    addPage() {
      //add dumpy page and select it
      this.pages.push(this.dummy);

      this.activePage = this.dummy;
    },
    savePage(e, id) {
      e.preventDefault();

      if (this.activePage.id) {
        //add new page
        //TO DO fetch
      } else {
        //edit existing page
        //TO DO fetch
      }
    },
  },
};
